import React, { useEffect, useState } from "react";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";

import { BsPhone, BsChatText, BsEnvelope } from "react-icons/bs";
import noData from "../../assets/images/no-data.png";

const Upcoming = ({ data }) => {
  const [languageData, setLanguageData] = useState(null);
  const [formattedDate, setFormattedDate] = useState("");

  const getImagePath = (imagePath) => {
    const fileName = imagePath.split("/").pop();
    return `./assets/images/faces/${fileName}`;
  };

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/dashboard/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
    if (data?.appointments?.length > 0) {
      const rawDate = data.appointments[0].date;

      const dateObj = new Date(rawDate);

      const formattedDate = new Intl.DateTimeFormat(
        cookieLang === "fr" ? "fr-FR" : "en-US",
        {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        },
      ).format(dateObj);

      const finalDate =
        cookieLang === "en" ? formattedDate.replace(/\//g, "-") : formattedDate;

      setFormattedDate(finalDate);
    }
    /* if (data?.appointments?.length > 0) {
      const rawDate = data.appointments[0].date;

      const [month, day, year, hour, minute] = rawDate.split(/[-\s:]/);
      const dateTime = new Date(`${year}-${month}-${day}T${hour}:${minute}:00`);

      const formattedDate = new Intl.DateTimeFormat(
        cookieLang === "fr" ? "fr-FR" : "en-US",

        {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }
        
      ).format(dateTime);

      const finalDate =
        cookieLang === "en" ? formattedDate.replace(/\//g, "-") : formattedDate;
      setFormattedDate(finalDate);
    } */
  }, []);

  if (!languageData) {
    return <div></div>;
  }
  const appointments = data?.appointments ?? 0;
  return (
    <div className="col-xl-6 text-start">
      <div className="card custom-card">
        <div className="card-header d-flex justify-content-between">
          <div className="flex-1">
            <div className="card-title">{languageData.appointments.title}</div>
          </div>
          <div className="ms-auto">
            <a
              data-interaction="view_all_appointment_button"
              href="portal/consultations?tab=appointments"
              className="btn btn-outline-light btn-sm text-muted"
            >
              {languageData.appointments.view_all}
            </a>
          </div>
        </div>
        <div className="card-body">
          {data.appointments?.length > 0 ? (
            <ul className="list-unstyled mb-0">
              {data.appointments.map((appointment) => {
                const date = new Date(appointment.date);
                const formattedDate =
                  `${date.getUTCFullYear()}-` +
                  `${String(date.getUTCMonth() + 1).padStart(2, "0")}-` +
                  `${String(date.getUTCDate()).padStart(2, "0")} ` +
                  `${String(date.getUTCHours()).padStart(2, "0")}:` +
                  `${String(date.getUTCMinutes()).padStart(2, "0")}`;

                /*  const formattedDate = new Date(appointment.date)
                  .toLocaleString("en-GB", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                    timeZone: "UTC",
                  })
                  .toLowerCase(); */

                return (
                  <li className="list-item" key={appointment.id}>
                    <div className="d-flex align-items-center justify-content-between w-100">
                      {/* Left section */}
                      <div className="d-flex align-items-center">
                        <a
                          data-interaction="expert_image"
                          href={`${process.env.REACT_APP_PLATFORM_URL}/expert-details?id=${appointment.expert.id}`}
                          className="me-3"
                        >
                          <img
                            src={appointment.expert?.image}
                            alt={appointment.expert?.nickname}
                            className="avatar rounded-circle"
                          />
                        </a>
                        <div>
                          <p className="mb-2 fw-semibold fs-18">
                            {appointment.expert?.nickname}
                          </p>
                          {/* {appointment.subject && (
                            <span className="badge bg-success">
                              {appointment.subject}
                            </span>
                          )} */}
                        </div>
                      </div>

                      {/* Type & Date */}
                      <div className="d-flex flex-column align-items-start fs-15">
                        <span className="badge bg-dark-transparent">
                          {appointment.notification.type === "call" && (
                          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57a.84.84 0 0 0-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 0 1-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1z"></path></svg>
                          )}
                          {appointment.notification.type === "sms" && (
                          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z"></path></svg>
                          )}
                          {appointment.type === "email" && <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z"></path></svg>}{" "}
                          {appointment.notification.type === "call"
                            ? languageData.appointments.consultation_phone
                            : languageData.appointments.consultation_email}
                        </span>
                        <small className="text-muted d-block mt-1 fs-14">
                          {formattedDate}
                        </small>
                      </div>

                      {/* Actions */}
                      <div className="dropdown">
                        <a
                          data-interaction="actions_button_upcoming"
                          href="#"
                          className="tx-inverse"
                          data-bs-toggle="dropdown"
                        >
                          <i className="bi bi-three-dots"></i>
                        </a>
                        <ul className="dropdown-menu">
                          <li>
                            <a
                              data-interaction="view_appointment"
                              href="portal/consultations?tab=appointments"
                              className="dropdown-item border-bottom"
                            >
                              {languageData.appointments.view}
                            </a>
                          </li>
                          {/*  <li>
                            <a className="dropdown-item border-bottom">
                              {languageData.appointments.cancel}
                            </a>
                          </li> */}
                        </ul>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : (
            <span class="mb-0 fs-18 font-15">⚊</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Upcoming;
